import { render, staticRenderFns } from "./dynamic-link.vue?vue&type=template&id=2b08ee9b"
import script from "./dynamic-link.vue?vue&type=script&lang=js"
export * from "./dynamic-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports